import { useQuery } from 'react-query';

import { checkMFAEnabled as queryFn } from 'api/endPoints/checkMFAEnabled';
import { TMfaType } from 'api/queries/getUserDetail.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryCheckMFAEnabled = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['CheckMFAEnabled', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.email),
    });
};

export interface QueryParams {
    email: string | undefined;
    password: string | undefined;
}

interface QueryResponse {
    mfaType: TMfaType;
    valid: boolean;
    mfaInit: boolean;
}
